const app = state => state.app
const device = state => state.app.device
const sidebar = state => state.app.sidebar
const effect = state => state.app.effect
const menuitems = state => state.menu.items
const isLogin = state => {
    return !!state.app.token
}
const componententry = state => {
    return state.menu.items.filter(
        c => c.meta && c.meta.label === 'Components'
    )[0]
}

const getUser = state => state.app.user

const isAuditDetail = state => {
    return state.app.isAuditDetail
}

export {
    app,
    device,
    sidebar,
    effect,
    menuitems,
    componententry,
    isLogin,
    getUser,
    isAuditDetail
}



// WEBPACK FOOTER //
// ./src/store/getters.js